import { twMerge } from 'tailwind-merge';

import { ErrorMessage } from '@lib/forms/ErrorMessage';
import { ExternalLink } from '../Clickables/ExternalLink/ExternalLink';
import { Text } from '../Text/Text';
import { ReactNode } from 'react';

interface ErrorBannerProps {
  errors: (ErrorMessage | string | undefined)[];
  className?: string;
  errorType?: 'webGLDisabled';
}

export const ErrorBanner = ({ errors, errorType, className = '' }: ErrorBannerProps): ReactNode => {
  return errors.length > 0 ? (
    <div
      className={twMerge(
        'bg-sea-foam text-error-shade motion-safe:animate-fadeInFast my-4',
        className,
      )}
      role="alert"
      data-testid="ErrorBanner"
    >
      {errors.length > 1 ? (
        <ul className="m-0 pl-4">
          {errors.map((error, index) => (
            <li className="mb-2 list-disc last:mb-0" key={`error-banner-${index}`}>
              {typeof error === 'string' ? error : error?.errorMessage}
            </li>
          ))}
        </ul>
      ) : (
        <Text className="m-0" variant="sm">
          {typeof errors[0] === 'string' ? errors[0] : errors[0]?.errorMessage}
        </Text>
      )}
      {errorType === 'webGLDisabled' && (
        <Text className="m-0" variant="sm">
          <ExternalLink
            variant="textPrimary"
            href="https://fishbrainhelp.zendesk.com/hc/en-us/articles/22539020086812-WebGL-error-message-while-trying-to-access-the-Map-on-fishbrain-com"
            className="underline"
            target="_blank"
          >
            Click here
          </ExternalLink>{' '}
          to enable WebGL.
        </Text>
      )}
    </div>
  ) : null;
};
